/*global _LTracker*/

class Log {
  meta = {};
  init({ accountId, pcuid }) {
    this.meta = { ...this.meta, accountId, pcuid };
  }
  info(info) {
    _LTracker.push({ ...this.meta, ...info, type: "info" });
  }
  error(err) {
    _LTracker.push({ ...this.meta, ...err, type: "error" });
  }
}

export default new Log();
